import { render, staticRenderFns } from "./ForgotReset.vue?vue&type=template&id=d837d738"
import script from "./ForgotReset.js?vue&type=script&lang=js&external"
export * from "./ForgotReset.js?vue&type=script&lang=js&external"
import style0 from "./ForgotReset.vue?vue&type=style&index=0&id=d837d738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports